import SubNavigationMobile from './childComponents/SubNavigationMobile'
import SubNavProfile from './childComponents/SubNavProfile'
import {ref, onBeforeMount, computed} from 'vue'
import addScrollCallback from "../../foundation/js/addScrollCallback";
import { useStore } from 'vuex';


export default {
    name: "SubNavigation",
    components: {SubNavigationMobile, SubNavProfile},
    props: {
        userData: {
            type: Object,
            required: false
        }
    },
    setup(props){
        const store = useStore()
        const mobileMenuOpen = ref(false)

        const overlay = document.createElement('div')
        overlay.classList.add(
            'kb-page-overlay__cover',
            'kb-page-overlay--subnavigation'
        )

        let bodysize = 0
        const toggleMobileMenu = function (e,originalTrigger) {
            mobileMenuOpen.value = !mobileMenuOpen.value
            overlay.classList.toggle('kb-page-overlay--subnavigation--visible')

            // move focus to original trigger button on the page
            if(!mobileMenuOpen.value){
                if(originalTrigger){
                    originalTrigger.focus()
                }
            }
 
            // close the mobilemenu when the screen resizes
            // this to prevent the menu from staying open if the screen resizes to desktop
            const overlayElement = document.body
            const resizeObserver = new ResizeObserver((entry) => {
                if(!bodysize){
                    bodysize = entry[0].contentRect.width
                } else {
                    bodysize = 0
                    mobileMenuOpen.value = false
                    overlay.classList.remove('kb-page-overlay--subnavigation--visible')
                    resizeObserver.unobserve(overlayElement)
                }

            })
            resizeObserver.observe(overlayElement);
        }

        const smallScreensStickyControls = function () {
            const oldScrollY = ref(0)
            const subNav = document.querySelector('.kb-sub-navigation')

            const showClass = 'kb-sub-navigation--mobile-sticky'

            addScrollCallback(() => {
                const direction =
                    window.scrollY - oldScrollY.value > 0 ? 'down' : 'up'
                oldScrollY.value = window.scrollY
                const scrolledOverViewportHeight = window.pageYOffset > 250 // window.innerHeight

                //show subnav when scrolling up once we are past a certain threshold
                if (direction === 'up' && scrolledOverViewportHeight) {
                    // show sticky
                    // remove hide nav above wrapper to animate in
                    subNav.classList.add(showClass)
                } else {
                    if (subNav.classList.contains(showClass)) {
                        subNav.classList.remove(showClass)
                    }
                }

                return false
            })
        }

        overlay.addEventListener('click', toggleMobileMenu)

        onBeforeMount(() => {
            document.documentElement.classList.add('kb-has-subnav')
            document.body.appendChild(overlay)
            smallScreensStickyControls()
            store.dispatch('main/setUserData', props.userData)
        })

        return {
            toggleMobileMenu,
            mobileMenuOpen
        }
    }
}
